<div class="locale-selector" [ngClass]="{'selected': selected}" (click)="handleClick($event)">
  <div class="locale-flag" [ngSwitch]="locale.country_code">
    <icon-us-flag *ngSwitchCase="'us'"></icon-us-flag>
    <icon-ca-flag *ngSwitchCase="'ca'"></icon-ca-flag>
  </div>
  <div class="locale-name" [ngClass]="{'selected': selected}">{{locale.label}}</div>
</div>
